import styled              from "styled-components";

import { NavBarVariants  } from "src/components/features/common/nav-bar";
import { ToolbarVariants } from "src/components/features/main/common/toolbar";

import { cssFlexColumn   } from "src/providers/theme/shared";



export type ProductCounterPhotoExampleLayout = {
  paddings: number[];

  width: number; 
  height: number;

  navbarVariant: NavBarVariants;
  toolbarVariant: ToolbarVariants;

};

export const layout_light: ProductCounterPhotoExampleLayout = {
  paddings: [16],

  width: 100,
  height: 100,

  navbarVariant: "lightblue",
  toolbarVariant: "light",
};

export const layout_dark: ProductCounterPhotoExampleLayout = {
  ...layout_light,
};

export const Screen = styled.div<{
  layout: ProductCounterPhotoExampleLayout;
}>`
  width: ${(args) => args.layout.width}vw;
  height: ${(args) => args.layout.height}dvh;

  ${cssFlexColumn};
  justify-content: space-between;
`;

export const ScreenBody = styled.div<{
  layout: ProductCounterPhotoExampleLayout;
}>`
  padding: ${(args) => args.layout.paddings[0]}px;
`;

export const Image = styled.img<{
  layout: ProductCounterPhotoExampleLayout;
}>`
  width: ${(args) => args.layout.width}%;
`;
